import { PayloadAction } from '@reduxjs/toolkit';
import { Store } from '@sv-support-sdk/shared-types';
import { createTicketsSlice, ticketsInitialState } from '@sv-support-sdk/store';

interface IInitialState extends Store.Tickets.ITicketsState {
  activeTab: 'tickets' | 'chats';
}

const initialState: IInitialState = { ...ticketsInitialState, activeTab: 'tickets' };

const tickets = createTicketsSlice({
  name: 'tickets',
  initialState: initialState,
  reducers: {
    setActiveTab: (state: IInitialState, action: PayloadAction<'tickets' | 'chats'>) => {
      state.activeTab = action.payload;
    },
    resetState: (state) => ({
      ...initialState,
      unreadMessages: state.unreadMessages,
      activeTab: state.activeTab,
      listMeta: {
        ...initialState.listMeta,
        hash: state.listMeta.hash,
      },
    }),
  },
});

export const ticketsActions = {
  ...tickets.actions,
  setActiveTab: tickets.actions.setActiveTab,
};

export default tickets.reducer;
